<script setup>
import { ref, computed, reactive, onMounted } from "vue";
import axios from "axios"; /*cmdでのインストール未完了*/
import { format } from "date-fns";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { useStore } from "@/store/authStore";
import RaceDateSelectDialog from "@/components/RaceDateSelectDialog.vue";
import RaceDatePlaceSelectDialog from "@/components/RaceDatePlaceSelectDialog.vue";
import RaceDatePlaceRaceNoSelectDialog from "@/components/RaceDatePlaceRaceNoSelectDialog.vue";
import RacePlaceSelectDialog from "@/components/RacePlaceSelectDialog.vue";
import RaceRegistrationNoSelectDialog from "../components/RaceRegistrationNoSelectDialog.vue";
import { useApiStore } from "@/store/apiStore";

import { Tooltip } from "bootstrap";

// ツールチップ使用準備
new Tooltip(document.body, {
  selector: "[data-bs-toggle='tooltip']",
});

const apiStore = useApiStore();

const store = useStore(); // Pinia storeを使用します
const accessToken = computed(() => {
  if (store.getAuthToken) {
    return store.getAuthToken; // 「payload」オブジェクトの中の「name」フィールドを取得します
  } else {
    return null;
  }
});

const tokenHeaders = {
  headers: {
    Authorization: `Bearer ${accessToken.value}`,
  },
};

let results = ref(null);
const paginatedResults = computed(() => {
  return results.value;
});

const searchDate = ref(format(new Date(), "yyyy-MM-dd"));

const dialogItems = reactive({ title: "", date: "" });
const message = ref("");

// POST先URL
const apiUrl = apiStore.getXmlPath; //`http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/xml/`

// 日時文字列から時刻のみ切り取り
function toTimeString(data) {
  if (data === null || data === undefined) {
    return "";
  }
  return format(new Date(data), "HH:mm");
}

function toDateTimeString(data) {
  if (data === null || data === undefined) {
    return "";
  }
  return format(new Date(data), "yyyy/MM/dd HH:mm:ss");
}

// 各更新ボタンイベント
function monthSchedule() {
  Object.assign(dialogItems, {
    title: "月間スケジュール更新",
    date: searchDate.value,
  });
}

function raceInfo() {
  Object.assign(dialogItems, {
    title: "レース情報更新",
    date: searchDate.value,
  });
}

function raceCard() {
  Object.assign(dialogItems, { title: "出走表更新", date: searchDate.value });
}

function lastInfo() {
  Object.assign(dialogItems, { title: "直前情報更新", date: searchDate.value });
}

function odds() {
  Object.assign(dialogItems, { title: "オッズ更新", date: searchDate.value });
}

function raceResult() {
  Object.assign(dialogItems, {
    title: "レース結果更新",
    date: searchDate.value,
  });
}
function article() {
  Object.assign(dialogItems, {
    title: "レース記事更新",
    date: searchDate.value,
  });
}
function month() {
  Object.assign(dialogItems, { title: "月別成績更新", date: searchDate.value });
}
function period() {
  Object.assign(dialogItems, { title: "期別成績更新", date: searchDate.value });
}

/*データ取得、変換、値が存在するか確認*/
onMounted(async () => {
  await search();
});

// ダイアログ結果処理
const dialogResult = async (obj) => {
  console.log(obj);
  if (!obj.res) {
    return;
  }

  var reqUrl = "";
  var sendUpdateRequest = {};
  switch (obj.dialogId) {
    // 月間スケジュール
    case "MonthlySchedule":
      message.value = obj.date;
      sendUpdateRequest.dataType = "1";
      reqUrl = `${apiUrl}/${obj.date}`;
      break;

    // レース情報
    case "RaceInfo":
      message.value = obj.date + " " + obj.place;
      sendUpdateRequest.dataType = "2";
      sendUpdateRequest.raceTruck = obj.place;
      reqUrl = `${apiUrl}/${obj.date}`;
      break;

    // 出走表
    case "RaceCard":
      message.value = obj.date + " " + obj.place;
      sendUpdateRequest.dataType = "3";
      sendUpdateRequest.raceTruck = obj.place;
      reqUrl = `${apiUrl}/${obj.date}`;
      break;

    // 直前情報
    case "LastInfo":
      message.value = obj.date + " " + obj.place;
      sendUpdateRequest.dataType = "9";
      sendUpdateRequest.raceTruck = obj.place;
      reqUrl = `${apiUrl}/${obj.date}`;
      break;

    // オッズ
    case "Odds":
      message.value = obj.date + " " + obj.place + " " + obj.raceNo;
      sendUpdateRequest.dataType = "4";
      sendUpdateRequest.raceTruck = obj.place;
      sendUpdateRequest.raceNo = obj.raceNo;
      reqUrl = `${apiUrl}/${obj.date}`;
      break;

    // レース結果
    case "RaceResult":
      message.value = obj.date + " " + obj.place;
      sendUpdateRequest.dataType = "5";
      sendUpdateRequest.raceTruck = obj.place;
      reqUrl = `${apiUrl}/${obj.date}`;
      break;

    // レース記事
    case "Article":
      message.value = obj.date + " " + obj.place;
      sendUpdateRequest.dataType = "6";
      sendUpdateRequest.raceTruck = obj.place;
      reqUrl = `${apiUrl}/${obj.date}`;
      break;

    // 月別成績
    case "MonthlyFarewell":
      message.value = obj.place;
      sendUpdateRequest.dataType = "7";
      sendUpdateRequest.raceTruck = obj.place;
      reqUrl = `${apiUrl}/${searchDate.value}`;
      break;

    // 期別成績
    case "Farewell":
      message.value = "" + obj.registrationNo;
      sendUpdateRequest.dataType = "8";
      sendUpdateRequest.registrationNumber = obj.registrationNo;
      reqUrl = `${apiUrl}/${searchDate.value}`;
      break;
    default:
  }
  message.value += " " + obj.dialogId;

  console.log(reqUrl);
  const response = await axios
    .put(reqUrl, sendUpdateRequest, tokenHeaders)
    .catch(function (error) {
      console.log(error.toJSON());
      alert("更新要求エラー\n" + error);
    });
  if (!response) {
    console.log("更新要求エラー");
    return;
  }

  console.log(response);
};

// 検索ボタン処理
const search = async () => {
  console.log("開始");

  const fullUrl = `${apiUrl}/${searchDate.value}`;
  console.log(fullUrl);
  const response = await axios
    .get(fullUrl, tokenHeaders)
    .catch(function (error) {
      console.log(error.toJSON());
      alert("検索エラー\n" + error);
    });
  if (!response) {
    console.log("検索エラー");
    return;
  }

  console.log(response);
  if (response.status == 200) {
    results.value = response.data.xml;
    console.log(results.value);
  }
};
</script>

<template>
  <div>
    <div class="content_parent registration d-flex flex-column">
      <!--<p class="mt-1 text-danger">{{ message }}</p>-->
      <div class="title content_line" style="margin-bottom: 1em">
        <div class="item_parent">
          <div class="content_title">
            <div class="texttitle">レース日</div>
          </div>
          <div class="content_item flex-column">
            <div class="d-flex align-items-center">
              <VueCtkDateTimePicker
                class=""
                :button-clear="false"
                v-model="searchDate"
                format="YYYY-MM-DD"
                formatted="YYYY年MM月DD日"
                :no-header="true"
                :no-button-now="true"
                :placeholder="'レース日'"
                no-label
                no-clear-button
                auto-close
                only-date
              />
              <button
                class="xmlupdate_search_button submit_button"
                v-on:click="search"
              >
                検索
              </button>
            </div>
          </div>
        </div>
      </div>
      <p style="margin-bottom: 0; font-size: 14px">
        非同期で処理されるため、更新には時間がかかります
      </p>
      <div>
        <div class="fixed-table table-responsive">
          <table
            class="result_table table-striped table-bordered xmlupdate_table_list"
            aria-colspan="8"
            style="border: none"
          >
            <thead>
              <tr>
                <th class="xmlupdate_table_cell_size" rowspan="2" nowrap>
                  レース場
                </th>
                <th class="xmlupdate_table_cell_size" nowrap>月間スケ</th>
                <th class="xmlupdate_table_cell_size" nowrap>レース情</th>
                <th class="xmlupdate_table_cell_size" nowrap>出走表</th>
                <th class="xmlupdate_table_cell_size" nowrap>直前情報</th>
                <th class="xmlupdate_table_cell_size" nowrap>オッズ</th>
                <th class="xmlupdate_table_cell_size" nowrap>結果</th>
                <th class="xmlupdate_table_cell_size" nowrap>記事</th>
                <th class="xmlupdate_table_cell_size" nowrap>月別</th>
                <th class="xmlupdate_table_cell_size" nowrap>期別</th>
              </tr>
              <tr class="result_table_th">
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="monthSchedule"
                      data-bs-toggle="modal"
                      data-bs-target="#MonthlySchedule"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="raceInfo"
                      data-bs-toggle="modal"
                      data-bs-target="#RaceInfo"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="raceCard"
                      data-bs-toggle="modal"
                      data-bs-target="#RaceCard"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="lastInfo"
                      data-bs-toggle="modal"
                      data-bs-target="#LastInfo"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="odds"
                      data-bs-toggle="modal"
                      data-bs-target="#Odds"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="raceResult"
                      data-bs-toggle="modal"
                      data-bs-target="#RaceResult"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="article"
                      data-bs-toggle="modal"
                      data-bs-target="#Article"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="month"
                      data-bs-toggle="modal"
                      data-bs-target="#MonthlyFarewell"
                    >
                      更新
                    </button></a
                  >
                </th>
                <th>
                  <a
                    ><button
                      type="button"
                      class="xmlupdate_update_button submit_button"
                      v-on:click="period"
                      data-bs-toggle="modal"
                      data-bs-target="#Farewell"
                    >
                      更新
                    </button></a
                  >
                </th>
              </tr>
            </thead>
            <tbody class="result_tbody_bgcolor">
              <tr
                class="xmlupdate_table_fixed"
                v-for="(result, index) in paginatedResults"
                :key="result.raceTruck"
                :index="index"
              >
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="result.raceTruck"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.monthlySchedule)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.monthlySchedule)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.raceInfo)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.raceInfo)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.raceTable)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.raceTable)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.previousInfo)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.previousInfo)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.ozzu)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.ozzu)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.result)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.result)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.articles)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.articles)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.monthlyFarewell)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.monthlyFarewell)"
                ></td>
                <td
                  class="xmlupdate_table_cell_size"
                  v-text="toTimeString(result.farewell)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  :title="toDateTimeString(result.farewell)"
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <RaceDateSelectDialog
      dialogId="MonthlySchedule"
      :title="dialogItems.title"
      :date="searchDate"
      @result="dialogResult"
    />
    <RaceDatePlaceSelectDialog
      dialogId="RaceInfo"
      :title="dialogItems.title"
      :date="searchDate"
      @result="dialogResult"
    />
    <RaceDatePlaceSelectDialog
      dialogId="RaceCard"
      :title="dialogItems.title"
      :date="searchDate"
      @result="dialogResult"
    />
    <RaceDatePlaceSelectDialog
      dialogId="LastInfo"
      :title="dialogItems.title"
      :date="searchDate"
      @result="dialogResult"
    />
    <RaceDatePlaceRaceNoSelectDialog
      dialogId="Odds"
      :title="dialogItems.title"
      :date="searchDate"
      @result="dialogResult"
    />
    <RaceDatePlaceSelectDialog
      dialogId="RaceResult"
      :title="dialogItems.title"
      :date="searchDate"
      @result="dialogResult"
    />
    <RaceDatePlaceSelectDialog
      dialogId="Article"
      :title="dialogItems.title"
      :date="searchDate"
      @result="dialogResult"
    />
    <RacePlaceSelectDialog
      dialogId="MonthlyFarewell"
      :title="dialogItems.title"
      @result="dialogResult"
    />
    <RaceRegistrationNoSelectDialog
      dialogId="Farewell"
      :title="dialogItems.title"
      @result="dialogResult"
    />
  </div>
</template>

<style scoped>
.xmlupdate_search_button {
  width: 10em;
  height: 2em;
}

.xmlupdate_update_button {
  padding: 0 0;
  margin: 0 0;
  width: 80%;
  height: 2em;
}

/*検索結果一覧部分のCSS*/

.xmlupdate_table_list {
  min-width: 5em;
  max-width: 50em;
}

.xmlupdate_table_fixed {
  text-align: center;
  height: 2em;
}

.xmlupdate_table_cell_size {
  height: 2em;
  width: 4em;
  padding: 1px;
}
</style>
